<template>
<div class="card">
    <div class="card-header">Payroll Review Details</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="38" :requestId="request.id"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <BaseMultiCheckboxInput v-model="payrollActions"
                                            :v="$v.payrollActions"
                                            slug="payroll-actions"
                                            :options="payrollOptions"
                                            label="Payroll Actions"
                                            :readonly="true"
                    />
                </b-col>
            </b-row>
<!--employee name, division, dept id, employid-->
            <b-row>
              <b-col cols="12" lg="3">
              <BaseTextOutput label="Employee Name" :value="request.selectedCandidateName"/>
            </b-col>
              <b-col cols="12" lg="3">
                <BaseTextOutput label="Employee ID" :value="request.selectedCandidateEmployeeId"/>
              </b-col>
              <b-col cols="12" lg="3">
                <BaseTextOutput label="Division" :value="request.division" />
              </b-col>
              <b-col cols="12" lg="3">
                <BaseTextOutput label="Department ID" :value="request.departmentId"/>
              </b-col>
            </b-row>
<!--classification, bargaining unit, FTE (employment condition, Appt Type-->
            <b-row>
                <b-col cols="12" lg="3">
                  <BaseTextOutput label="Final Classification" :value="request.proposedClassification"/>
                </b-col>
                <b-col cols="12" lg="3">
                  <BaseTextOutput :value="getBargainingUnitText(request.bargainingUnit)"
                                  label="Bargaining Unit"/>
                </b-col>
                <b-col cols="12" lg="3">
                  <BaseTextOutput label="Employment Condition" :value="request.positionScheduleValue.description"/>
                </b-col>
                <b-col cols="12" lg="3">
                  <BaseTextOutput label="Appointment Type"
                                  :value="_.get(request, 'appointmentValue.description', '')"/>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" lg="3">
                    <BaseTextOutput label="FLSA Status"
                                    :value="getFlsaStatusText(request.flsaStatusValue)"/>
                </b-col>
            </b-row>
<!--Location, hire status, leave credit, Schedule-->
             <b-row>
                <b-col cols="12" lg="3">
                  <BaseTextOutput label="Position Location" :value="request.positionLocation"/>
                </b-col>
                <b-col cols="12" lg="3">
                  <BaseTextOutput :value="request.hiringAction"
                                  label="Type of Hire"/>
                </b-col>
                <b-col cols="12" lg="3">
                  <BaseTextOutput label="Leave Credit"
                                  :value="request.leaveCredit"/>
                </b-col>
                <b-col cols="12" lg="3">
                  <BaseTextOutput label="Work Schedule" :value="request.workScheduleValue.description"/>
                </b-col>
            </b-row>
<!--Start date, if rehire (rehire time period field)-->
            <b-row>
                <b-col cols="12" lg="6">
                  <BaseTextOutput label="Effective Start Date"
                                  :value="request.effectiveStartDate"/>
                </b-col>

                <b-col cols="12" lg="6">
                  <BaseTextOutput label="Rehire Time Period"
                                  :value="request.rehireTimePeriod" />
                </b-col>

            </b-row>
            <b-row>
                <b-col lg="6">
                    <BaseTextOutput label="Backpay Date"
                                    :value="request.backpayDate"/>
                </b-col>
                <b-col lg="6">
                    <BaseTextOutput label="Reallocation Effective Date"
                                    :value="request.reallocationEffectiveDate"/>
                </b-col>
            </b-row>

          <b-row>
            <b-col>
              <BaseTextOutput v-model="request.payrollComments" label="Internal Comments"/>
            </b-col>
          </b-row>

          <div v-if="request.payrollActionsString">
            <b-button type="button" variant="primary" @click="complete">Complete</b-button>
            <b-button type="button" variant="outline-primary" @click="save">Save</b-button>
            <b-button type="button" variant="outline-danger" v-b-modal.modal-return-previous-lifecycle>Return to Transaction Specialist</b-button>
          </div>
        </b-form>
    </div>
  <b-modal id="modal-return-previous-lifecycle" hide-header hide-footer @hidden="close">
    <h2>Return To Previous Lifecycle</h2>
    <hr/>
    <form ref="form" @submit.prevent="onReturnToPriorLifecycle()">
      <BaseParagraphInput v-model="returnPreviousLifecycleComments"
                          :v="$v.returnPreviousLifecycleComments"
                          slug="returnPreviousLifecycleComments"
                          :required="$v.returnPreviousLifecycleComments.$params.required ? true : false"
                          label="Reason for returning to the previous lifecycle"/>
      <b-button @click="close" style="margin-right:15px;">Cancel</b-button>
      <b-button type="submit" variant="primary" :disabled="$v.returnPreviousLifecycleComments.$invalid">Submit</b-button>
    </form>
  </b-modal>
</div>

</template>

<script>
import axios from "axios"
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'
import _ from "lodash"
import { commonOptions } from '@/mixins/commonOptions.js'
import BaseTextOutput from "@/components/BaseTextOutput";
import {  required,  maxLength, } from 'vuelidate/lib/validators'



export default {
  components: {
    BaseTextOutput,
    LifecycleCheckList,
  },
  mixins: [
    commonOptions
  ],
  props: {
    request: Object
  },
  data() {
    return {
      checklistComplete: false,
      saveOnly: false,
      returnPreviousLifecycleComments: null,
      payrollActions: []
    }
  },
  validations() {
    return {
      returnPreviousLifecycleComments: {required: false, maxLength: maxLength(4000)},
      payrollActions: {required:false},
    }
  },
  computed: {
    _: function (){
      return _
    },
  },
  created() {
      if(this.request.payrollActionsString){
          this.payrollActions = this.request.payrollActionsString.split(",")
      }
  },

  methods: {
    updateChecklistStatus(b) {
      this.checklistComplete = b
    },

    save() {
      this.saveOnly = true
      this.complete()
      this.saveOnly = false
    },

    complete() {
      if (!this.saveOnly) {
        this.$refs.checklist.emitCheckListStatus()
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.$nextTick(() => {
            document.getElementById('form-container').scrollIntoView()
          })
          return
        }
      }

        let payload = {
            requestId: this.request.id,
            requestStatus: '38',
            payrollAction: 'REV',
            saveOnly: this.saveOnly
        }

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/payroll/complete`, payload)
          .then(response => {
            if(this.saveOnly === false){
              this.showRootToast("HRM Request New Employee tasks Completed", "Success", "success")
            }
            else{
              this.showRootToast("HRM Request Has Been Saved", "Success", "success")
            }
            this.$router.push('/home')
          })

    },
    close() {
      this.$bvModal.hide("modal-return-previous-lifecycle")
      this.returnPreviousLifecycleComments=null
    },
    onReturnToPriorLifecycle(){
      let payload = {
        id: this.request.id,
        comment: this.returnPreviousLifecycleComments
      }

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/payroll/return`, payload)
          .then(response => {
            this.showRootToast("HRM Request Has Been Sent Back To Transactions Specialist", "Success", "success")
            this.$router.push('/home')
          })
    },


    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true
      })

    },
    getBargainingUnitText(bargainingUnitCode){
      return this.bargainingUnitOptions.find(code => code.value === bargainingUnitCode).text

    },
    getFlsaStatusText(flsaStatusCode) {
        var result = 'not provided'
        this.flsaStatusOptions.forEach((item) => {
            if (item.value === flsaStatusCode) {
                result = item.text
            }
        })
        return result
    },
  }
}
</script>